/*
Small library which detects the presence of adblock
 */
class AdblockDetectorHandler {
  adblockDetected = false;
  detectorHasRun = false;

  constructor() {
    window.AdblockDetectorHandler = this;
    this.requestDetector();
  }

  // Requests the detector script
  requestDetector = () => {
    const s = document.createElement('script');
    s.src = '/wp-content/themes/arn/frontend/lib/abd.js';
    s.id = 'detector-script';
    s.onload = window.AdblockDetectorHandler.checkAdblockStatus;
    document.body.appendChild(s);
  };

  checkAdblockStatus = () => {
    window.adblockDetector.init({
      found: window.AdblockDetectorHandler.callbackAdblockDetected,
      notFound: window.AdblockDetectorHandler.callbackAdblockNotDetected,
    });
  };

  callbackAdblockDetected = () => {
    this.adblockDetected = true;
    this.detectorHasRun = true;
  };

  callbackAdblockNotDetected = () => {
    this.adblockDetected = false;
    this.detectorHasRun = true;
  };
}

export default () => new AdblockDetectorHandler();
